import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ADMIN_NAVIGATION_SECTIONS, resolveAdminPageContext } from '../navigation/adminNavigation';
import './Sidebar.css';

type SidebarProps = {
  open?: boolean;
  onNavigate?: () => void;
};

export default function Sidebar({ open = false, onNavigate }: SidebarProps) {
  const { pathname } = useLocation();
  const activeSection = resolveAdminPageContext(pathname)?.section ?? null;
  const [selection, setSelection] = useState<{ pathname: string; title: string | null }>({ pathname, title: activeSection });
  if (selection.pathname !== pathname) setSelection({ pathname, title: activeSection });
  const expandedTitle = selection.pathname === pathname ? selection.title : activeSection;
  return (
    <aside className={open ? 'sidebar open' : 'sidebar'}>
      <nav className="sidebar-nav">
        {ADMIN_NAVIGATION_SECTIONS.map((section, index) => {
          const collapsible = section.items.length > 1;
          const expanded = !collapsible || expandedTitle === section.title;
          return (
          <div key={section.title} className="nav-section">
            {collapsible ? <button type="button" className="nav-section-title nav-section-toggle" aria-expanded={expanded} aria-controls={`sidebar-section-${index}`} onClick={() => setSelection({ pathname, title: expanded ? null : section.title })}><span>{section.title}</span><span aria-hidden="true">{expanded ? '−' : '+'}</span></button> : <span className="nav-section-title">{section.title}</span>}
            <div id={`sidebar-section-${index}`} className="nav-section-items" hidden={!expanded}>
            {section.items.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                onClick={onNavigate}
                className={({ isActive }) => isActive || (to === '/analytics/behavior' && pathname === '/analytics/credits') ? 'nav-item active' : 'nav-item'}
              >
                <span className="nav-icon"><Icon /></span>
                <span className="nav-label">{label}</span>
              </NavLink>
            ))}
            </div>
          </div>
        ); })}
      </nav>
    </aside>
  );
}
